@if (show()) {
  <output class="app-loader" aria-busy="true">
    <div class="app-loader__stage">
      <!-- Outer arc — rotates anti-clockwise -->
      <span class="app-loader__arc app-loader__arc--outer"></span>

      <!-- Inner arc — rotates clockwise -->
      <span class="app-loader__arc app-loader__arc--inner"></span>

      <!-- Central logo -->
      <span class="app-loader__core">
        <img [src]="logo.src" [alt]="logo.alt" class="app-loader__logo" />
      </span>
    </div>

    @if (message()) {
      <p class="app-loader__message">{{ message() }}</p>
    }
  </output>
}
